var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.getFragment(_vm.content),{tag:"component",attrs:{"content":_vm.content,"settings":_vm.settings}})
}
var staticRenderFns = []

export { render, staticRenderFns }